(() => {
  function formatFragranceText() {
    document.querySelectorAll('.product-tab__more-over-geur .metafield-rich_text_field').forEach(root => {
      if (root.dataset.fragranceFormatted || root.querySelector('h1,h2,h3,h4,a,ul,ol,strong,em')) return;
      const lines = root.textContent.trim().split(/(Hoe ruikt [^?]+\?|Hoelang blijft [^?]+\?|Wanneer draag je [^?]+\?|Is [^?]+ het proberen waard\?)/).map(line => line.trim()).filter(Boolean);
      if (lines.length < 8 || lines.length % 2 !== 0) return;
      if (!lines.every((line, index) => index % 2 !== 0 || /^(Hoe ruikt |Hoelang blijft |Wanneer draag je |Is ).*\?$/.test(line))) return;
      const fragment = document.createDocumentFragment();
      lines.forEach((line, index) => {
        const element = document.createElement(index % 2 === 0 ? 'h3' : 'p');
        element.textContent = line;
        fragment.appendChild(element);
      });
      root.replaceChildren(fragment);
      root.dataset.fragranceFormatted = 'true';
    });
  }
  formatFragranceText();
  if (!window.parfumsamplesFragranceListener) {
    document.addEventListener('shopify:section:load', formatFragranceText);
    window.parfumsamplesFragranceListener = true;
  }
})();
